import { shareLinkStyles } from "@insite/content-library/Widgets/ProductDetails/ProductDetailsShareLink";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

shareLinkStyles.link = {
    link: {
        typographyProps: {
            size: 16,
            css: css`
                color: ${getColor("primary.main")} !important;
                text-decoration: underline;
            `,
        },
        css: css`
            &:hover span {
                color: #7a7a7a !important;
            }
        `,
    },
};
